import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../login/services/authentication.service';
import { catchError, map } from 'rxjs/operators';
import { User } from '../models/user.model';
import { SnackbarService } from '../services/snackbar.service';
import { Observable, throwError as observableThrowError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private snackbarService: SnackbarService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.check(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.check(route, state);
  }

  private check(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = route.queryParamMap.get('token');
    // Check if we have a token in url
    if (!!token) {
      return this.authenticationService.tokenLogin(token).pipe(
        catchError((err: any, caught: Observable<User>) => {
          this.snackbarService.addMessage('Sorry we\'re not be able to authenticate you. Please contact an administrator.');
          this.router.navigate(['/login']);
          return observableThrowError(err);
        }),
        map((user: User) => {
          if (!!user) {
            // If user is not attached to a badge redirect to badge login.
            // if (!user.badge) {
            //   this.router.navigate(['/login/attach-badge']);
            //   return false;
            // }

            if (!user.id) {
              this.router.navigate(['/login/attach-user']);
              return false;
            }

            if (!user.isInformationConfirmed) {
              this.router.navigate(['/user/profile']);
            }

            const url = state.url;
            const redirect = url.split('?', 1);

            this.router.navigate(redirect);
            return false;
          }
        })
      );
    }

    // Check if user is connected
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {

      // If user is not attached to a badge redirect to badge login.
      // if (!currentUser.badge &&
      //   state.url.indexOf('/login') < 0 &&
      //   state.url.indexOf('/login/attach-badge') < 0) {
      //   this.router.navigate(['/login/attach-badge']);
      //   return false;
      // }

      if (!currentUser.id &&
        state.url.indexOf('/login') < 0 &&
        state.url.indexOf('/login/attach-user') < 0) {
        this.router.navigate(['/login/attach-user']);
        return false;
      }

      if (currentUser.isInformationConfirmed === false &&
        state.url.indexOf('/user/profile') < 0 &&
        state.url.indexOf('/login/attach-badge') < 0 &&
        state.url.indexOf('/login/attach-user') < 0) {
        this.router.navigate(['/user/profile'], { queryParams: { returnUrl: state.url } });
        return false;
      }

      return true;
    }

    // Redirect
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
